import { ENTER, COMMA } from "@angular/cdk/keycodes";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { Store } from "@ngrx/store";
import { WarehouseContainerService, ApiVisa } from "blg-akaun-ts-lib";
import { PermissionStates } from "../../modules/permission/permission-controller/root";
import { SearchStates } from "../../modules/search/search-controller/states";
import { Observable, of } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
} from "rxjs/operators";
import { SubSink } from "subsink2";
import { AppConfig } from "../../visa";

@Component({
  selector: "app-advanced-search-wms-container-dropdown",
  templateUrl: "./advanced-search-wms-container-dropdown.component.html",
  styleUrls: ["./advanced-search-wms-container-dropdown.component.css"],
})
export class WmsContainerAdvancedSearchDropdownComponent implements OnInit {
  @Input() wmsContainerControl = new FormControl();
  @Output() selectionChange = new EventEmitter();
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;


  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredWmsContainers$: Observable<any[]>;
  wmsContainers: any[] = [];
  allWmsContainers: any[] = [];
  toppingsControl = new FormControl([]);
  apiVisa: ApiVisa = AppConfig.apiVisa;

  @ViewChild("wmsContainerInput") wmsContainerInput: ElementRef<HTMLInputElement>;
  companyTargets: string[] = [];

  constructor(
    private wmsContainerService: WarehouseContainerService,
    private readonly store: Store<SearchStates>,
    private readonly permissionStore: Store<PermissionStates>
  ) {}

  ngOnInit(): void {
    let dto = {
        order: "DESC",
        orderBy: "updated_date"
      }
    this.subs.sink = this.wmsContainerService.getByCriteriaPost(dto, this.apiVisa).subscribe((wmsResponse: any) => {
      const wmsListing = wmsResponse.data.map((data, index) => ({
        name: data.bl_wms_container_hdr.name,
        guid: data.bl_wms_container_hdr.guid,
        code: data.bl_wms_container_hdr.code,
      }));
      this.allWmsContainers = wmsListing;
      this.filteredWmsContainers$ = of(this.allWmsContainers)
      // console.log(this.allWarehouses)
    });
    this.wmsContainerControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((data) => this.filterWmsContainers(data));
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || "").trim();
    // Add our company
    if (value) {
      this.wmsContainers.push(value);
    }

    // Clear the input value
    event.input.value = "";

    this.wmsContainerControl.setValue(null);

    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_Space_Container_Allocation_ContainerField({
        wmsContainers: this.wmsContainers,
      })
    );
  }

  remove(wmsContainer: any): void {
    // console.log("remove", wmsContainer)
    const i = this.wmsContainers.findIndex(
      (value) => value.guid === wmsContainer.guid
    );
    this.wmsContainers[i].selected = false
    this.wmsContainers.splice(i, 1);
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_Space_Container_Allocation_ContainerField({
        containers: this.wmsContainers,
      })
    );
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log(event.option);
    this.wmsContainers.push(event.option.value);
    this.wmsContainerInput.nativeElement.value = "";
    this.wmsContainerControl.setValue(null);
  }

  filterWmsContainers(search: string)  {
    const searchResults = this.searchWmsContainers(search);
    this.filteredWmsContainers$ = of(searchResults);
  }


  searchWmsContainers(searchTerm: string): any[] {
    if (typeof searchTerm === 'string') { // Check if searchTerm is a string
      const lowerSearchTerm = searchTerm.toLowerCase();
      let output = [];
      this.allWmsContainers.forEach((container) => {
        if (container.name.toLowerCase().includes(lowerSearchTerm) || container.code.toLowerCase().includes(lowerSearchTerm)) {
          output.push(container);
        }
      });
      console.log("output -->", output);
      return output;
    } else {
      // Handle the case where searchTerm is not a string, maybe return an empty array or throw an error
      return [];
    }
  }
  


  optionClicked(event: Event, wmsContainer: any) {
    event.stopPropagation();
    this.toggleSelection(wmsContainer);
  }

  toggleSelection(wmsContainer: any) {
    console.log(wmsContainer);
    wmsContainer.selected = !wmsContainer.selected;
    this.wmsContainerInput.nativeElement.value = "";
    if (wmsContainer.selected) {
      this.wmsContainers.push(wmsContainer);
      this.viewModelStore.dispatch(
        this.ColumnViewActions.setAdvanceSearch_Space_Container_Allocation_ContainerField({
          containers: this.wmsContainers,
        })
      );
    } else {
      const i = this.wmsContainers.findIndex(
        (value) => value.guid === wmsContainer.guid
      );
      this.wmsContainers.splice(i, 1);
      this.viewModelStore.dispatch(
        this.ColumnViewActions.setAdvanceSearch_Space_Container_Allocation_ContainerField({
          containers: this.wmsContainers,
        })
      );
    }
  }

  onReset() {
    this.wmsContainers = [];
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_Space_Container_Allocation_ContainerField({
        wmsContainers: [],
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
